import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useDisclosure } from '@mantine/hooks';

export const useFetchRemoteData = (getDataFunc, { query, skip }) => {
	const dispatch = useDispatch();
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isFetching, setIsFetching] = useState(false);
	const [isInitialLoad, setIsInitialLoad] = useState(true);
	const [refetch, handlers] = useDisclosure(false);

	useEffect(() => {
		if (skip) return;

		if (!query) return;

		if (isInitialLoad) {
			setIsLoading(true);
		} else {
			setIsFetching(true);
		}

		setError(null);

		const dispatched = dispatch(getDataFunc(query));
		// RTK createAsyncThunk returns a promise with .unwrap(); plain thunk middleware may return a normal Promise.
		const resultPromise =
			dispatched && typeof dispatched.unwrap === 'function'
				? dispatched.unwrap()
				: Promise.resolve(dispatched);

		resultPromise
			.then(res => setData(res))
			.catch(err => setError(err))
			.finally(() => {
				setIsLoading(false);
				setIsFetching(false);
				setIsInitialLoad(false);
			});
	}, [query, skip, refetch]);

	return {
		data,
		error,
		isLoading,
		isFetching,
		refetch: handlers.toggle,
	};
};
